<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-marcar-llegada"
      style="background-color: #00000082"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Marcar llegada</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="tipo_sitio">Tipo Sitio</label>
              <select
                class="form-control form-control-sm"
                v-model="form.tipo_sitio"
                :class="$v.form.tipo_sitio.$invalid ? 'is-invalid' : 'is-valid'"
                @change="(form.sitio_id = null), (sitio = {})"
              >
                <option value="">Seleccione...</option>
                <option value="1">Sitio</option>
                <option value="2">Punto Gestión</option>
              </select>
            </div>
            <div class="form-group" v-if="form.tipo_sitio">
              <label for="sitio_punto_gestion">
                {{ form.tipo_sitio == 1 ? "Sitio" : "Punto Gestión" }}
              </label>
              <v-select
                :class="[
                  $v.form.sitio_id.$invalid ? 'is-invalid' : 'is-valid',
                  $store.getters.getDarkMode ? 'dark-vselect' : '',
                ]"
                v-model="sitio"
                placeholder="Sitio"
                label="nombre"
                class="form-control form-control-sm p-0"
                :options="listasForms.sitiosPuntosGestion"
                @search="buscarSitiosPuntosGestion"
                @input="selectSitioPuntoGestion()"
              ></v-select>
            </div>
            <div class="form-group">
              <label for="fecha">Fecha</label>
              <input
                type="date"
                class="form-control form-control-sm"
                id="fecha_inicial"
                v-model="form.fecha"
                :class="$v.form.fecha.$invalid ? 'is-invalid' : 'is-valid'"
              />
              <div class="error" v-if="!$v.form.fecha.required">
                Ingrese una Fecha
              </div>
            </div>
            <div class="form-group">
              <label for="hora">Hora</label>
              <!-- <input
                  type="time"
                  class="form-control form-control-sm"
                  id="fecha_inicial"
                  v-model="form.hora"
                  :class="$v.form.hora.$invalid ? 'is-invalid' : 'is-valid'"
                /> -->
              <input
                type="text"
                class="form-control form-control-sm"
                id="fecha_inicial"
                v-model="form.hora"
                :class="$v.form.hora.$invalid ? 'is-invalid' : 'is-valid'"
                v-mask="{
                  mask: '99:99',
                  hourFormat: '24',
                }"
              />
              <div class="error" v-if="!$v.form.hora.required">
                Ingrese una Hora
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form.$invalid"
              @click="marcarLlegada()"
            >
              Marcar llegada
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
const timeFormat = helpers.regex(
  "timeFormat",
  /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/
);
import { required, helpers } from "vuelidate/lib/validators";
export default {
  name: "GestionHidrocarburosMarcarLlegada",
  components: {
    vSelect,
  },
  data() {
    return {
      sitio: {},
      form: {
        viaje_id: null,
        tipo_sitio: null,
        sitio_id: null,
        fecha: null,
        hora: null,
        ruta_id: null,
      },
      listasForms: {
        sitiosPuntosGestion: [],
      },
    };
  },
  validations: {
    form: {
      tipo_sitio: {
        required,
      },
      sitio_id: {
        required,
      },
      fecha: {
        required,
      },
      hora: {
        required,
        timeFormat,
      },
    },
  },
  methods: {
    marcarLlegada() {
      if (!this.$v.form.$invalid) {
        axios({
          method: "POST",
          url: "api/admin/centralTrafico/saveLlegada",
          data: this.form,
        })
          .then((response) => {
            this.$parent.cargarDatos();
            this.$refs.closeModal1.click();
            this.$swal({
              icon: "success",
              title: "Se marcó la llegada exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((error) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarSitiosPuntosGestion(search, loading) {
      if (search != "") {
        loading(true);
        axios
          .get("api/admin/centralTrafico/rutaSitios", {
            params: {
              tipo_sitio: this.form.tipo_sitio,
              ruta_id: this.form.ruta_id,
            },
          })
          .then((response) => {
            this.listasForms.sitiosPuntosGestion = response.data;
            loading(false);
          })
          .catch((error) => {
            loading(false);
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    selectSitioPuntoGestion() {
      this.form.sitio_id = null;
      if (this.sitio) {
        this.form.sitio_id = this.sitio.id;
      }
    },

    llenarModal(viaje_id, ruta_id) {
      this.form.viaje_id = viaje_id;
      this.form.ruta_id = ruta_id;
      this.form.tipo_sitio = null;
      this.form.sitio_id = null;
      this.sitio = {};
      this.form.fecha = moment().format("YYYY-MM-DD");
      this.form.hora = moment().format("HH:mm:ss");
    },
  },
};
</script>
